import service from './service';
import { API_URL_CLOUD } from '../config/config';

export const getBirthplaceCitiesApi = () => {
  return service.extGet(`${API_URL_CLOUD}/city`);
};
